import {
  API_EXCHANGE_RATE_CREATE,
  API_EXCHANGE_RATE_DELETE,
  API_EXCHANGE_RATE_LIST,
} from "./apiPaths";
import axiosMiddleware from "./axiosMiddleware";
// --------------------------------------------------------------------------------
export const createExchangeRateAPI = ({
  sourceCurrencyId,
  targetCurrencyId,
  rate,
}) => {
  let postData = {
    sourceCurrencyId,
    targetCurrencyId,
    rate,
  };
  return axiosMiddleware({
    method: "post",
    url: API_EXCHANGE_RATE_CREATE,
    data: postData,
  });
};
export const getExchangeRateListAPI = () => {
  return axiosMiddleware({
    method: "get",
    url: API_EXCHANGE_RATE_LIST,
  });
};
export const deleteExchangeRateAPI = ({ id }) => {
  let deleteData = {
    id,
  };
  return axiosMiddleware({
    method: "delete",
    url: API_EXCHANGE_RATE_DELETE,
    data: deleteData,
  });
};
